<template>
  <div>
    <md-switch :name="formRow.name" v-model="value">
      <label>{{ $t(formRow.title) }}</label>
    </md-switch>
  </div>
</template>
<script>
import {extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", required);
export default {
  name: "CheckBox",
  props: {
    objeto: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    formRow: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    field_index: {
      type: Number,
      default: -1,
      required: false
    }
  },
  data() {
    return {
      obj: this.objeto
    };
  },
  created() {
  },
  computed: {
    value: {
      get() {
        return this.obj[this.formRow.name];
      },
      set: function (newValue) {
        this.obj[this.formRow.name] = newValue;
        this.$emit("on-update", {name: this.formRow.name, value: newValue});
      }
    }
  }
};
</script>
